/* eslint-disable */

import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import { useRouter } from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FileHuongDan } from "@/services/api/HoSoCanBoCongChuc/FileService";

export default function useDonViService() {
  const toast = useToast();
  const { route, router } = useRouter();

  const refListTable = ref(null);

  const perPage = ref(10);

  const currentPage = ref(1);

  const perPageOptions = [10, 25, 50, 100];

  const searchQuery = ref("");
  const sortBy = ref("");
  const isSortDirDesc = ref(true);
  const refUserListTable = ref(null);

  const fields= [
    {
      key: "STT",
      label: "STT",
      thStyle: "text-align:center; width:50px",
      tdClass: "justify-content-center",
    },
    {
      label: "Tên tệp tin",
      key: "fileName",
    },

    {
      key: "action",
      label: "Tải về",
      thStyle: "text-align:center; width:100px;",
      tdClass: "d-flex justify-content-center",
    },
  ];

  //TODO: de dk neu get theo DonVi

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });
  const refetchData = () => {
    refUserListTable.value.refresh();
  };



  const getDataTable = (ctx, callback) => {
    // let condition = {
    //   // start: currentPage.value,
    //   // limit: perPage.value,
    //   codefile: "HUONGDAN"
    // };
    FileHuongDan().then((response) => {
       
      if (!response.isError) {
        const data = response.data;
        console.log("response", data);
        callback(data);
        // totalUsers.value = totalRows;
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };

  watch([currentPage, perPage], () => {
    refetchData();
  });


  

  return {
    refListTable,
    perPage,
    refetchData,
    refUserListTable,
    dataMeta,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,

    fields,
    getDataTable
  };
}
